// extracted by mini-css-extract-plugin
module.exports = {"o1kjxlod":"o1kjxlod","i1k5eqjx":"i1k5eqjx"};